// features/auth/authSlice.js
import { createSlice } from "@reduxjs/toolkit";
import { authApiSlice } from "./crmAdminApiSlice";

const storedAuth = JSON.parse(localStorage.getItem("auth"));
const initialState = {
  isAuthenticated: storedAuth?.isAuthenticated || false,
  isReporterAuthenticated: false,
  loading: false,
  error: null,
  user: storedAuth?.user || null,
  countryCode: "+1",
  phoneNumber: "",
  password: "",
  otp: ["", "", "", ""],
  showOtpPopup: false,
  otpSent: false,
  role: storedAuth?.role || null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginSuccess: (state, action) => {
      state.isAuthenticated = true;
      state.loading = false;
      state.user = action.payload?.user || null;
      state.role = "admin";
      localStorage.setItem(
        "auth",
        JSON.stringify({
          isAuthenticated: true,
          user: state.user,
          role: "admin",
        }),
      );
    },
    loginReporterSuccess: (state, action) => {
      // Action for reporter login
      state.isReporterAuthenticated = true;
      state.loading = false;
      state.user = action.payload?.user || null;
      state.role = "reporter";
      localStorage.setItem(
        "auth",
        JSON.stringify({
          isAuthenticated: true,
          user: state.user,
          role: "reporter",
        }),
      );
    },
    logoutSuccess: () => {
      localStorage.removeItem("auth"); // Clear stored login data
      return initialState;
    },
    setFormData: (state, action) => {
      state[action.payload.name] = action.payload.value;
    },
    setOtpDigit: (state, action) => {
      state.otp[action.payload.index] = action.payload.value;
    },
    setOtp: (state, action) => {
      state.otp = action.payload;
    },
    setShowOtpPopup: (state, action) => {
      state.showOtpPopup = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setOtpSent: (state, action) => {
      state.otpSent = action.payload;
    },
    resetAuthState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        authApiSlice.endpoints.verifyOtp.matchFulfilled,
        (state, { payload }) => {
          if (payload.success) {
            state.isAuthenticated = true;
          }
        },
      )
      .addMatcher(
        authApiSlice.endpoints.checkReporterLogin.matchFulfilled,
        (state, { payload }) => {
          if (payload.success) {
            state.isReporterAuthenticated = true;
            state.user = payload.user; // Save reporter user data
          }
        },
      );
    // ... other matchers
  },
});

export const {
  setFormData,
  setOtpDigit,
  setOtp,
  setShowOtpPopup,
  setError,
  setLoading,
  setOtpSent,
  resetAuthState,
  loginSuccess,
  logoutSuccess,
} = authSlice.actions;

export default authSlice.reducer;
